mutation EntityEnvironmentalDelete($input: EntityEnvironmentalDeleteInput!) {
  entityEnvironmentalDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
